import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useInsightsUtils } from "../../hooks/useInsightsUtils";
import { useInsights } from "../../Context/insightContext";
import { UserContext, UserPayload } from "../../Context/userContext";
import { IEscalationInfoRes } from "../../Models/applicationModels";
import EventHistoryModal from "../../Pages/InsightsPage/components/eventHistoryModal/eventHistoryModal.index";
import { DEFAULT_INSIGHTS_DATE_RANGE, DEFAULT_INSIGHTS_UI_FILTERS } from "../../Pages/InsightsPage/components/insightsHeader/insightsHeader.constants";

const InsightsWrapper = () => {
  const {
    GetFinalTechnicalOutcomeList,
    GetApplicationList,
    UpdateTableInfo,
    isEventHistoryModalOpen,
    isEventHistoryLoading,
    eventHistoryResponse,
    HandleCloseEventHistoryModal,
    HandleRetryEventHistory
  } = useInsightsUtils()

  const {
    rowsPerPage,
    page,
    filterInfoStatic,
    setSortInfo,
    setInsightsUiFilters,
    sortInfoRef,
    filterInfoRef,
    dateRangeRef,
    setSearchText,
    searchTextRef
  } = useInsights();

  const [availableEscalations, setAvailableEscalations] = useState<IEscalationInfoRes[]>([]);

  const { setShowLoader } = React.useContext(UserContext) as UserPayload;

  useEffect(() => {
    // Calls to made when component is mounted for Insights Page.
    let isCancelled = false;

    const loadInsightsPageData = async () => {
      try {
        setShowLoader(true);

        setSortInfo(null);
        setInsightsUiFilters(DEFAULT_INSIGHTS_UI_FILTERS);
        sortInfoRef.current = null;
        filterInfoRef.current = [];
        dateRangeRef.current = DEFAULT_INSIGHTS_DATE_RANGE;
        setSearchText("");
        searchTextRef.current = "";

        const [applicationRes] = await Promise.all([
          GetApplicationList(rowsPerPage, page),
          GetFinalTechnicalOutcomeList(),
        ]);

        if (isCancelled || applicationRes === null) {
          return;
        }

        filterInfoStatic.current = applicationRes.availableFilters;
        await UpdateTableInfo(applicationRes, null, setAvailableEscalations);
      } catch (error) {
        console.error("Error fetching application list or final technical outcome list:", error);
      } finally {
        if (!isCancelled) {
          setShowLoader(false);
        }
      }
    };

    loadInsightsPageData();

    return () => {
      isCancelled = true;
    };
  }, []);

  return (
    <>
      <Outlet context={{ availableEscalations: availableEscalations }} />
      <EventHistoryModal
        isOpen={isEventHistoryModalOpen}
        isLoading={isEventHistoryLoading}
        responseData={eventHistoryResponse}
        onClose={HandleCloseEventHistoryModal}
        onRetry={HandleRetryEventHistory}
      />
    </>
  );
};

export default InsightsWrapper;
